/* @flow */

import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';
import DiffusionModal from './DiffusionModal';

type Props = {
  isFetching: boolean,
  roles: Array<UserRole>,
  onTargetAdded: (target: Target) => void,
};

type State = {
  isModalOpened: boolean,
};

class AddTargetButton extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      isModalOpened: false,
    };
  }

  onShowModal = () => this.setState({ isModalOpened: true });
  onCloseModal = () => this.setState({ isModalOpened: false });

  onSelected = (target: Target) => {
    this.props.onTargetAdded(target);
    this.onCloseModal();
  };

  render() {
    const { isFetching, roles } = this.props;
    const { isModalOpened } = this.state;

    return (
      <div>
        <Button
          onClick={this.onShowModal}
          type="button"
          icon="add user"
          loading={isFetching}
          labelPosition="right"
          content="Ajouter"
        />
        <DiffusionModal
          isOpened={isModalOpened}
          title="Ajout de destinataires"
          roles={roles}
          onClose={this.onCloseModal}
          onSelected={this.onSelected}
        />
      </div>
    );
  }
}

export default AddTargetButton;



// WEBPACK FOOTER //
// ./src/modules/diffusion/components/AddTargetButton.js